import { cn } from "@postdaily/ui/lib/utils";

import type { ChannelStatus } from "@/lib/platforms";

/**
 * The LIVE / IN REVIEW / SOON status pill used on the Landing channel showcase
 * and the Integrations cards. Green for shipped adapters, amber for a live one
 * the network is still reviewing (`platformInReview`), brand-blue for "coming
 * soon". The channel data itself lives in `lib/platforms.ts`.
 */
export function ChannelBadge({
  status,
  inReview = false,
  className,
}: {
  status: ChannelStatus;
  inReview?: boolean;
  className?: string;
}) {
  const reviewing = status === "live" && inReview;

  return (
    <span
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-md px-1.5 py-[3px] font-bold text-[10px] tracking-[0.03em]",
        reviewing
          ? "bg-[oklch(0.95_0.06_85)] text-[oklch(0.5_0.11_70)]"
          : status === "live"
            ? "bg-[oklch(0.94_0.05_155)] text-[oklch(0.48_0.12_155)]"
            : "bg-[oklch(0.96_0.024_264)] text-[oklch(0.5_0.12_264)]",
        className,
      )}
    >
      {reviewing ? "IN REVIEW" : status === "live" ? "LIVE" : "SOON"}
    </span>
  );
}
